import { render, staticRenderFns } from "./tab-vertical.vue?vue&type=template&id=88ea56f4&scoped=true"
import script from "./tab-vertical.vue?vue&type=script&lang=js"
export * from "./tab-vertical.vue?vue&type=script&lang=js"
import style0 from "./tab-vertical.vue?vue&type=style&index=0&id=88ea56f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ea56f4",
  null
  
)

export default component.exports